var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"avatar",style:(_vm.styles),attrs:{"title":_vm.name}},[_c('span',{staticClass:"symbol",style:(_vm.initialStyles)},[(_vm.icon)?_c('span',[_c('i',{class:_vm.icon})]):_c('span',[_vm._v(_vm._s(_vm._f("truncate")(_vm.initials,2, '')))])]),_c('div',{staticClass:"photo",style:(_vm.photoStyles)})])
}
var staticRenderFns = []

export { render, staticRenderFns }